import { render, staticRenderFns } from "./ContainerLoader.vue?vue&type=template&id=95ed56ba&scoped=true"
import script from "./ContainerLoader.vue?vue&type=script&lang=js"
export * from "./ContainerLoader.vue?vue&type=script&lang=js"
import style0 from "./ContainerLoader.vue?vue&type=style&index=0&id=95ed56ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ed56ba",
  null
  
)

export default component.exports